import TopicList from '../components/TopicList';

export default function StepSelectTopics({
  loading,
  topics,
  selectedTopics,
  onChange,
}) {
  return (
    <div>
      <h4>Select Topic(s)</h4>
      <TopicList
        loading={loading}
        topics={topics}
        selectedTopics={selectedTopics}
        onChange={onChange}
      />
    </div>
  );
}
